import { RightCircleFilled } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { Store } from 'antd/lib/form/interface';
import React, { useContext, useState } from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import InputPassword from 'components/atoms/InputPassword';
import Title from 'components/atoms/Title';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';
import { useNewPassword } from 'hooks/useNewPassword';

import zmenaHeslaApi from 'services/zmenaHesla';

import routePathEnum from 'enums/routePathEnum';

import passwordCheckValidation from 'utils/validations/passwordCheckValidation';
import passwordValidation from 'utils/validations/passwordValidation';

interface IZmenaHesla {}

const ZmenaHesla: React.FC<IZmenaHesla> = () => {
    const [form] = useForm();
    const { language } = useContext(Context);
    const { PasswordInput, isStrongEnough } = useNewPassword('passwordNew');
    const { navigateWorkaround } = useNavigateWorkaround();
    const [loading, setLoading] = useState<boolean>(false);
    const [status, setStatus] = useState<number>(0);
    const onFinish = ({ passwordOld, passwordNew }: Store) => {
        setLoading(val => !val);
        zmenaHeslaApi(passwordOld, passwordNew, language)
            .then(resp => setStatus(resp))
            .catch(err => setStatus(err.response.status))
            .finally(() => {
                setLoading(val => !val);
            });
    };
    const okReturn = () => (
        <div>
            <Row>
                <Col
                    span={24}
                    style={{
                        paddingBottom: 8
                    }}
                >
                    <Title text="EMP_INFO_ZMENA_OBNOVENI_HESLO" level={4} />
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <AnchorComponent link={true} to={routePathEnum.MAIN_PAGE}>
                        <ButtonComponent
                            buttontext="POKRACOVAT"
                            htmlType="button"
                            onClick={() => setStatus(0)}
                            id="pwNewRedirectBtn"
                        />
                    </AnchorComponent>
                </Col>
            </Row>
        </div>
    );

    const errReturn = () => (
        <div>
            <Row>
                <Col
                    span={24}
                    style={{
                        paddingBottom: 8
                    }}
                >
                    <Title text="HESLO_ZMENA_401" level={4} />
                </Col>
                <Col span={24}>
                    <ButtonComponent
                        buttontext="POKRACOVAT"
                        htmlType="button"
                        onClick={() => setStatus(0)}
                        id="ErrConfirm401Btn"
                    />
                </Col>
            </Row>
        </div>
    );

    const errWrongOldPwReturn = () => (
        <div>
            <Row>
                <Col
                    span={24}
                    style={{
                        paddingBottom: 8
                    }}
                >
                    <Title text="HESLO_PUVODNI_CHYBA" level={4} />
                </Col>
                <Col span={24}>
                    <ButtonComponent
                        buttontext="POKRACOVAT"
                        htmlType="button"
                        onClick={() => setStatus(0)}
                        id="ErrConfirmBtn"
                    />
                </Col>
            </Row>
        </div>
    );

    const defaultReturn = () => (
        <FormWrapper onFinish={onFinish} outForm={form}>
            <Title text="HESLO_NOVE_NADPIS" level={3} /> <TranslateText>HESLO_ZMENA_TEXT</TranslateText>
            <InputPassword label="HESLO_PUVODNI" name="passwordOld" type="password" rules={passwordValidation()} />
            {PasswordInput()}
            <InputPassword
                label="HESLO_NOVE_OVERENI"
                name="passwordCheck"
                type="password"
                autoComplete="new-password"
                dependencies={['passwordNew']}
                rules={passwordCheckValidation('passwordNew')}
            />
            <Row className="button-row">
                <ButtonComponent
                    buttontext="ZPET"
                    htmlType="button"
                    onClick={() => navigateWorkaround(routePathEnum.MUJ_PROFIL)}
                    type="default"
                    id="pwNewZpetBtn"
                />
                <ButtonComponent
                    buttontext="POKRACOVAT"
                    onClick={() => form.submit()}
                    icon={<RightCircleFilled />}
                    loading={loading}
                    id="pwNewSubmitBtn"
                    disabled={!isStrongEnough}
                />
            </Row>
        </FormWrapper>
    );

    return (
        <>
            {status ? <Title text="HESLO_NOVE_NADPIS" level={3} /> : null}
            {!status && defaultReturn()}
            {status === 200 && okReturn()}
            {status === 401 && errReturn()}
            {status === 404 && errWrongOldPwReturn()}
        </>
    );
};

export default ZmenaHesla;
